var map = {
	"./en_US.json": [
		33582,
		"src_assets_locale_menudishes_en_US_json"
	],
	"./id_ID.json": [
		41734,
		"src_assets_locale_menudishes_id_ID_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 84306;
module.exports = webpackAsyncContext;